import { Component, OnInit, HostBinding } from '@angular/core';
import { slideToRight } from '../../../shared/animations.collections';
import { EventListenerService } from '../../../services/close-listenenr.service';
import { NavMenu } from '../nav-menu';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { FeedbackInfo} from '../../../models/feedback-info.model';
import { ApiResponse } from '../../../models/api-response.model';
import { Subject, Subscription } from 'rxjs';
import { CommonService } from '../../../services/common.service';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-location',
    templateUrl: './location.component.html',
    styleUrls: ['./location.component.css'],
    animations: [slideToRight()]
})
export class LocationComponent extends NavMenu implements OnInit {

    @HostBinding('@slideToRight') ani;

    ngUnsubscribe: Subject<void> = new Subject<void>();

    public locations = [];

    title = "LOCATION";
    currentStore = null;
    chooseMode = false;
    sendComments:FeedbackInfo = <FeedbackInfo>{};
    locationForm: FormGroup;
    disableButton: boolean;
    errorMsg: string;
    showResult: boolean;
    imageFile: any;
    fileList: FileList;
    hasEmptyQuestions:boolean = true;
    response:ApiResponse;
    passQuestionSubscription$: Subscription;
    completeSubmission:boolean = false;
    fileListArr = [];

    constructor(
        closeListener: EventListenerService,        
        private commonService: CommonService,
    ) {
        super(closeListener);
    }

    ngOnInit():void {

      this.commonService.getWarehouseList().pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
        this.locations = res;
      });

      this.currentStore = JSON.parse(this.commonService.readCookie('myWarehouseLocation'));
    }


    public chooseLocation () {
      this.chooseMode = true;
    }

    public setMyStore(location) {
      this.commonService.createCookie('myWarehouseLocation', JSON.stringify(location), 365);
      this.commonService.updateLocation.next(location);
      this.currentStore = location;
      this.chooseMode = false;
    }
}
